module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.paginator.last_page > 1) ? _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "ui right floated pagination menu",
    staticStyle: {
      "flex-wrap": "wrap",
      "justify-content": "center"
    }
  }, [(_vm.paginator.current_page != 1) ? _c('router-link', {
    staticClass: "icon item",
    attrs: {
      "to": {
        name: _vm.goTo.name,
        params: Object.assign({}, _vm.goTo.params, {
          page: _vm.paginator.current_page - 1
        })
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paginator.last_page), function(link, index) {
    return _c('router-link', {
      staticClass: "item",
      class: {
        'active': _vm.paginator.current_page == index + 1
      },
      attrs: {
        "to": {
          name: _vm.goTo.name,
          params: Object.assign({}, _vm.goTo.params, {
            page: index + 1
          })
        }
      }
    }, [_vm._v(_vm._s(index + 1))])
  }), _vm._v(" "), (_vm.paginator.last_page != _vm.paginator.current_page) ? _c('router-link', {
    staticClass: "icon item",
    attrs: {
      "to": {
        name: _vm.goTo.name,
        params: Object.assign({}, _vm.goTo.params, {
          page: _vm.paginator.current_page + 1
        })
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })]) : _vm._e()], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20a5316a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodsPaginator.vue
// module id = 325
// module chunks = 1